import { createAction, handleActions } from 'redux-actions'

const setData = createAction('SCREENS/SUBBIES/SUB_PROJECTS/SET_DATA')
const resetData = createAction('SCREENS/SUBBIES/SUB_PROJECTS/RESET_DATA')

const defaultState = []

const reducer = handleActions(
  {
    [setData]: (state, { payload }) => payload,
    [resetData]: () => [],
  },
  defaultState,
)

export { setData, resetData, reducer }
